module.exports = __webpack_public_path__ + "logo_transparent-6900bab180aa3a46c34425e5367a218f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/logo_transparent.svg
// module id = 269
// module chunks = 76